import { useStore } from './store'

export function checkPermission(
  permissionName: string,
  exactMatch = false,
): boolean {
  const store = useStore()

  if (!permissionName) return true

  return (
    store.auth?.user?.permissions?.some((p) =>
      exactMatch
        ? p === permissionName
        : p.startsWith(`${permissionName}:`) ||
          p === permissionName ||
          p === '**:w',
    ) || false
  )
}
